module.exports = __webpack_public_path__ + "/static/assets/26255153f92ea41df149a58d3c3fe2cf.svg";